import React, { useState } from "react";
import {
  Container,
  Select,
  MenuItem,
  Modal,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
} from "@mui/material";
import API from "../../config/api";
import {
  InvoiceSummary,
  InvoiceDetail,
  MembersUpdated,
  TrainingList,
  DateForm,
  MemberStatus,
} from "../../components/Reports";
import styles from "./reports.module.scss";

const API_URL = process.env.API_URL;
const component = (
  onClose,
  onHandleData,
  onHandleLookById,
  reportMetadata,
  download
) => ({
  // summary: <InvoiceSummary onClose={onClose} />,
  detail: (
    <InvoiceDetail
      onClose={onClose}
      onGenerate={onHandleData}
      download={download}
      reportMetadata={reportMetadata}
    />
  ),
  members_updated: (
    <MembersUpdated onClose={onClose} onGenerate={onHandleData} />
  ),
  tallerParticipant: (
    <TrainingList
      onClose={onClose}
      reportMetadata={reportMetadata}
      download={download}
    />
  ),
  dateForm: (
    <DateForm
      onClose={onClose}
      reportMetadata={reportMetadata}
      download={download}
    />
  ),
  listOfMembers: (
    <MemberStatus
      onClose={onClose}
      download={download}
      reportMetadata={reportMetadata}
    />
  ),
});

const REPORT_METADATA = {
  membersByZone: {
    url: `member/members-by-zone`,
    canConsult: false,
    canPrint: true,
    datesForm: false,
    fileName: "memberByRegion.pdf",
  },
  listOfMembers: {
    url: `member/members-list-excel`,
    canConsult: true,
    canPrint: false,
    datesForm: false,
    formName: "listOfMembers",
    fileName: "AnestesiologiaMiembros.xlsx",
  },
  listMiembrosIncompleto: {
    url: `member/members_incomplete`,
    canConsult: false,
    canPrint: true,
    datesForm: false,
    fileName: "miembrosIncompleto.xlsx",
  },
  listOfAspirantMembers: {
    url: `member/aspirant_report`,
    canConsult: false,
    canPrint: true,
    dtatesForm: false,
    fileName: "miembros_aspirante.xlsx",
  },
  members_updated: {
    url: `member/members_updated`,
    canConsult: true,
    canPrint: false,
    title: "Miembros actualizados",
    datesForm: true,
  },
  summary: {
    url: `invoice/caja-resumen`,
    canPrint: true,
    datesForm: true,
    formName: "dateForm",
    fileName: "resumenDeCaja.pdf",
  },
  detail: {
    url: "invoice/caja-detalles",
    datesForm: true,
    canPrint: true,
    fileName: "invoiceDetails.xlsx",
  },
  accountMovement: {
    url: `accounting/movement`,
    datesForm: false,
    canConsult: false,
    canPrint: true,
    fileName: "movimientosCuentas.xlsx",
  },
  totalByGroupService: {
    datesForm: true,
    canPrint: true,
  },
  tallerParticipant: {
    // The T1-11-2024-tiva_y_ventiliacion should be a Drop down to be send as a param
    url: `taller_for_participant/participant_list`,
    datesForm: true,
    canConsult: false,
    canPrint: true,
    fileName: "TallerParticipantes.xlsx",
  },
  invoiceWithTaxNumber: {
    url: `invoice/invoice_tax_number`,
    datesForm: false,
    canConsult: false,
    canPrint: true,
  },
  totalServiceAmount: {
    url: `invoice/total_services`,
    canPrint: true,
    datesForm: true,
    formName: "dateForm",
    fileName: "total_de_service_en_fact.xlsx",
  },
};

const Reports = () => {
  const [reportType, setReportType] = useState("reports");
  const [reportData, setReportData] = useState({
    total: 0,
    data: [],
    dateIn: "",
    dateFn: "",
  });
  const [openDialog, setOpenDialog] = useState(false);

  async function downloadFile(filePath, fileNameWithExt) {
    await API.getDownloadFile(filePath, fileNameWithExt);
  }

  const handleClose = () => {
    setOpenDialog(false);
  };

  const downloadReport = () => {
    if (reportType !== "reports" && REPORT_METADATA[reportType].canPrint) {
      window.open(REPORT_METADATA[reportType].url, "download");
    }
  };

  const onHandleChange = (event) => {
    const { value } = event.target;

    setReportType(value);
    setReportData({
      total: 0,
      data: [],
      dateIn: "",
      dateFn: "",
    });
  };

  const onHandleData = async (dateStart, dateEnd) => {
    const data = await API.get(
      `${REPORT_METADATA[reportType].url}?dateIn=${dateStart}&dateFn=${dateEnd}`
    );

    setReportData({
      total: data.body.count,
      data: data.body.data,
      dateIn: dateStart,
      dateFn: dateEnd,
    });
    setOpenDialog(false);
  };

  const onHandleLookById = async (id) => {
    const downloadUrl = `${REPORT_METADATA[reportType].url}?id=${id}`;
    window.open(downloadUrl, "download");
    setOpenDialog(false);
  };

  const onHandleConsult = () => {
    if (
      REPORT_METADATA[reportType].datesForm ||
      REPORT_METADATA[reportType].formName
    ) {
      setOpenDialog(true);
    }
  };

  const onHandlePrint = () => {
    if (REPORT_METADATA[reportType].datesForm) {
      setOpenDialog(true);
    } else {
      //downloadReport();
     
      downloadFile(
        REPORT_METADATA[reportType].url,
        REPORT_METADATA[reportType].fileName
      );
    }
  };

  return (
    <Container>
      <h3>Reportes de sistema</h3>
      <div>
        <div className={styles.container}>
          <label htmlFor="selectReport">Elija un reporte</label>
          <Select
            id="selectReport"
            value={reportType}
            label="Elija un reporte"
            onChange={onHandleChange}
          >
            <MenuItem value="reports">Reportes</MenuItem>
            <MenuItem value="membersByZone">Miembros por zona</MenuItem>
            <MenuItem value="listOfMembers">Listado de miembros</MenuItem>
            <MenuItem value="listMiembrosIncompleto">
              Miembros incompleto
            </MenuItem>
            <MenuItem value="listOfAspirantMembers">
              Miembros aspirantes
            </MenuItem>
            <MenuItem value="members_updated">Miembros actualizados</MenuItem>
            <MenuItem value="summary">Reporte de caja </MenuItem>
            <MenuItem value="detail">Reporte de caja detallado</MenuItem>

            <MenuItem value="accountMovement">Movimiento de cuentas</MenuItem>
            <MenuItem value="tallerParticipant">
              Participantes por taller
            </MenuItem>
            <MenuItem value="invoiceWithTaxNumber">
              Facturas con comprobantes
            </MenuItem>
            <MenuItem value="totalServiceAmount">
              Total de Servicios facturados
            </MenuItem>
          </Select>
        </div>
        <div className={styles.btnContainer}>
          <Button
            variant="contained"
            disabled={!REPORT_METADATA[reportType]?.canConsult}
            onClick={onHandleConsult}
          >
            Consultar
          </Button>
          <Button
            onClick={onHandlePrint}
            variant="contained"
            disabled={!REPORT_METADATA[reportType]?.canPrint}
          >
            Generar archivo
          </Button>
        </div>
      </div>

      <Modal
        open={openDialog}
        onClose={handleClose}
        className="report_modal"
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {component(
          handleClose,
          onHandleData,
          onHandleLookById,
          REPORT_METADATA[reportType],
          downloadFile
        )[REPORT_METADATA[reportType]?.formName || reportType] || <></>}
      </Modal>
      {reportData.data.length ? (
        <div className={styles.consultContainer}>
          <h4 className={styles.title}>
            Consuleta de {REPORT_METADATA[reportType]?.title}
          </h4>
          <div className={styles.datesContainer}>
            <span className={styles.date}>{reportData.dateIn}</span>
            <span>/---\</span>
            <span className={styles.date}>{reportData.dateFn}</span>
          </div>
          <div className={styles.count}>
            <span>Total de actualizados:</span>
            <span>{reportData.total}</span>
          </div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">No.</TableCell>
                  <TableCell align="left">Cédula</TableCell>
                  <TableCell align="left">Nombres</TableCell>
                  <TableCell align="left">Apellidos</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData.data.map((row, index) => (
                  <TableRow key={`${index}-${row.identifier}`}>
                    <TableCell padding="checkbox" align="left">
                      {index || 0}
                    </TableCell>
                    <TableCell padding="checkbox">{row.identifier}</TableCell>
                    <TableCell padding="checkbox" align="left">
                      {row.names}
                    </TableCell>
                    <TableCell padding="checkbox" align="left">
                      {row.familyName}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {console.log("DATA***", reportData)}
        </div>
      ) : null}
    </Container>
  );
};

export default Reports;
